import React from 'react';
import { STATUS_COLORS } from '../../utils/formatters';

export default function StatusBadge({ status, size = 'sm' }) {
  const colorClass = STATUS_COLORS[status] || 'bg-gray-100 text-gray-700';
  const sizeClass = size === 'sm' ? 'text-xs px-2 py-0.5' : 'text-sm px-3 py-1';
  return (
    <span className={`inline-flex items-center rounded-full font-medium font-body ${colorClass} ${sizeClass}`} data-testid="status-badge">
      {status || '—'}
    </span>
  );
}
